<template>
    <fieldset class="w-full h-full overflow-y-auto flex flex-col gap-3">
        <div v-if="teamMembers == null" class="w-full flex items-center justify-start mt-2">
            <Spinner class="size-4" />
        </div>
        <div v-else-if="teamMembers.length == 0" class="w-full mt-2 text-sm text-left text-gray-500 italic">
            No members found. Try a different name or email,<br />or <a href="/team"
                class="text-birdie-blue hover:underline">add a
                member</a> to your
            workspace.
        </div>
        <div v-if="teamMembers != null" class="w-full">
            <div v-if="teamMembers.length > 4"
                class="w-full flex items-center justify-between h-7 bg-gray-100 rounded-md sticky top-0 px-2">

                <input type="text" v-model="search" :placeholder="searchPlaceholder"
                    class="text-left flex-grow inline py-0 mb-0 pr-2 pl-0 focus:ring-0 ring-0 outline-none bg-gray-100 focus:bg-gray-100 text-birdie-blue  border-0 border-gray-100 text-xs" />

                <div class="flex-shrink-0 flex items-center justify-end gap-x-1 w-26">
                    <select id="searchIn" name="searchIn" aria-label="searchIn" v-model="searchIn"
                        class="text-xs border-0 outline-none ring-0 pr-7 pb-0 pt-0 text-gray-500 w-26 text-right focus:ring-0 focus:ring-offset-0 focus:outline-none bg-gray-100">
                        <option value="all">All</option>
                        <option value="checked">Selected</option>
                        <option value="unchecked">Not Selected</option>
                    </select>
                    <!-- <ChevronDownIcon class="pointer-events-none size-4 pt-0.5 text-gray-500 -ml-2" aria-hidden="true" /> -->
                </div>
            </div>
            <div v-if="teamMembersFiltered.length == 0 && search != ''"
                class="w-full text-sm text-gray-500 italic mt-2 text-left">
                No members found. Try a different name or email,<br />or <a href="/team"
                    class="text-birdie-blue hover:underline">add a
                    member</a> to your
                workspace.
            </div>

            <div v-for="member in teamMembersFiltered" :key="member.id" class="space-y-5 mt-2 ml-1">
                <div class="flex gap-3 items-start justify-start">
                    <div class="flex h-6 shrink-0 items-start">
                        <div class="group grid size-3 grid-cols-1 pt-0.5">
                            <input :id="'member-' + member.id" aria-describedby="comments-description" name="member"
                                type="checkbox" :checked="memberSelectedIds.includes(member.id)"
                                class="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white  checked:bg-birdie-blue indeterminate:bg-birdie-blue focus-visible:outline-0 outline-none outline-0 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto focus:ring-0"
                                @change="toggleMember(member.id)" />
                            <!-- <svg class="pointer-events-none col-start-1 row-start-1 size-2.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
                                viewBox="0 0 14 14" fill="none">
                                <path class="opacity-0 group-has-[:checked]:opacity-100" d="M3 8L6 11L11 3.5"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path class="opacity-0 group-has-[:indeterminate]:opacity-100" d="M3 7H11"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> -->
                        </div>
                    </div>
                    <div class="text-xs">
                        <label :for="'member-' + member.id" class="flex flex-col w-full items-start justify-start">
                            <span
                                :class="[memberSelectedIds.includes(member.id) ? 'text-birdie-blue font-bold' : 'text-gray-900 font-medium', 'truncate']">{{
                                    member.name }}</span>
                            <span class="text-gray-500 truncate">{{ member.email }}</span>
                        </label>

                    </div>
                </div>
            </div>
        </div>
    </fieldset>
</template>

<script>
import Spinner from '@/Components/UI/Spinner'
import { ChevronDownIcon } from '@heroicons/vue/16/solid'

export default {
    name: 'FolderRestrictedTeamMembers',
    components: {
        Spinner,
        ChevronDownIcon
    },
    props: {
        folder: {
            type: Object,
            required: true
        },
        teamMembers: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            memberSelectedIds: [],
            search: '',
            searchIn: 'all'
        }
    },
    created() {
        this.memberSelectedIds = this.folder.memberSelectedIds || []
        console.log("Folder: ", this.folder, this.memberSelectedIds, this.teamMembers)
    },
    methods: {
        getTeamMembers() {
            return this.folder.users.map(user => user.name)
        },
        toggleMember(id) {
            if (this.memberSelectedIds.includes(id)) {
                // If ID exists, remove it
                this.memberSelectedIds = this.memberSelectedIds.filter(memberId => memberId !== id);
            } else {
                // If ID doesn't exist, add it
                this.memberSelectedIds.push(id);
            }
            this.$emit('updateMemberSelectedIds', this.memberSelectedIds)
        }
    },
    computed: {
        searchPlaceholder() {
            let placeholder = 'Search…'
            if (this.memberSelectedIds.length == 1) {
                placeholder += ' (1 member selected)'
            } else if (this.memberSelectedIds.length > 1) {
                placeholder += ' (' + this.memberSelectedIds.length + ' members selected)'
            }
            return placeholder
        },
        teamMembersFiltered() {
            let filtered = this.teamMembers
            // if (this.searchIn == 'all') {
            //     return this.teamMembers
            // }
            if (this.searchIn == 'checked') {
                filtered = this.teamMembers.filter(user => this.memberSelectedIds.includes(user.id))
            } else if (this.searchIn == 'unchecked') {
                filtered = this.teamMembers.filter(user => !this.memberSelectedIds.includes(user.id))
            }
            //return this.teamMembers.filter(member => member.name.toLowerCase().includes(this.search.toLowerCase()))
            return filtered.filter(user => {
                return user.name.toLowerCase().includes(this.search.toLowerCase()) || user.email.toLowerCase().includes(this.search.toLowerCase())
            })
        }
    }
}
</script>
